import { formatDecimal, formatDateForHumans, humanDateFormat, getCurrentTime } from '../services/utils';
// const { printTicket } = api.services.printService;
// const { getLaundryInfo, getSettingByName } = api.services.settingsService;
// const { getSaleByCodigo } = api.services.ventasService;
// const { getClienteByID } = api.services.clientesService;
// const { getUsuarioByID } = api.services.usuariosService;
export default {

  methods: {
    printTicket(){},
    getLaundryInfo(){},
    getSettingByName(){},
    getSaleByCodigo(){},
    getClienteByID(){},
    getUsuarioByID(){},
    printBillTicket(codigo, printType = 'RE_PRINT_INVOICE') {
      const numTicketsSetting = this.getSettingByName("num_new_bill_tickets");
      const numTickets = numTicketsSetting ? parseInt(numTicketsSetting.value) : 1;
      const laundryInfo = this.getLaundryInfo();
      const {
        nombreLavanderia,
        direccion: direccionLavanderia,
        telefono,
        ciudad,
        estado,
        pais,
        codigoPostal
      } = JSON.parse(laundryInfo.value);
      const nowDTStr = `${formatDateForHumans(new Date().toISOString())} ${getCurrentTime()}`;
      const fechaHora = nowDTStr.substring(0, nowDTStr.length - (":00".length));

      let data = null;

      switch (printType) {
        case 'NEW_BILL':
          data = this.setUpNewBillTicketPrintData();
          break;
        default:
          data = this.setUpInvoiceTicketPrintData(codigo);
          break;
      }

      const {
        folio,
        cajeroVendedor,
        nombreCliente,
        itemsVenta,
        granTotal,
        abono,
        saldo,
        fechaEntrega
      } = data;
      let ticketContent = {
        numTickets,
        folio,
        codigo,
        header: {
          nombreLavanderia,
          direccionLavanderia,
          ciudad,
          estado,
          pais,
          codigoPostal: `C.P. ${codigoPostal}`,
          telefonoLavanderia: `Tel. ${telefono}`,
          fechaHora
        },
        people: {
          cajeroVendedor,
          nombreCliente,
        },
        items: itemsVenta,
        totals: {
          granTotal,
          abono,
          saldo
        },
        footer: {
          fechaEntrega
        },
      };
      this.printTicket(ticketContent);
    },
    setUpInvoiceTicketPrintData(codigo) {
      const invoice = this.getSaleByCodigo(codigo);
      const {
        id,
        id_vendedor,
        id_cliente,
        servicios,
        productos,
        total,
        abono,
        saldo,
        fecha_entrega
      } = invoice;

      const usuario = this.getUsuarioByID(id_vendedor);
      const cliente = this.getClienteByID(id_cliente);
      const cajeroVendedor = usuario ? usuario.nombre : "NO EXISTE";
      const nombreCliente = cliente ? `${cliente.nombre} ${cliente.apellido}` : "NO EXISTE";
      const itemsVenta = [...JSON.parse(servicios), ...JSON.parse(productos)];
      const formattedDate = humanDateFormat(fecha_entrega, 'es');
      const fechaEntrega = `${formattedDate} hrs`;


      return {
        folio: id,
        cajeroVendedor,
        nombreCliente,
        itemsVenta,
        granTotal: total,
        abono,
        saldo,
        fechaEntrega
      };
    },
    setUpNewBillTicketPrintData() {
      const folio = this.$store.getters.nextFolio;
      const cajeroVendedor = this.user.nombre;
      const nombreCliente = `${this.billClientData.nombre} ${this.billClientData.apellido}`;

      const itemsVenta = this.billItems.map(item => {
        const total = formatDecimal(item.total);
        item.total = total;
        return item;
      });
      const fechaHoraStr = `${this.date} ${this.horaEntrega}`;
      const formattedDate = humanDateFormat(fechaHoraStr, 'es');
      const fechaEntrega = `${formattedDate} hrs`;
      const totales = itemsVenta.map(item => item.total);
      const granTotal = formatDecimal(totales.reduce((acumulador, itemTotal) => Number.parseFloat(acumulador) + Number.parseFloat(itemTotal)));
      const abono = formatDecimal(this.abono);
      const saldo = formatDecimal(this.computedSaldo);
      return {
        folio,
        cajeroVendedor,
        nombreCliente,
        itemsVenta,
        granTotal,
        abono,
        saldo,
        fechaEntrega
      };
    }
  }
}